<template>
  <div class="schedule_in">
    <indexTitle id="big_title" page="true" english_title="Schedule" chinese_title="年度全台檔期"></indexTitle>
    <!-- <div style="background:#eeeeee;"> -->
    <recommend />
    <!-- </div> -->
    <div id="category_side_bar" :class="{ 'open': openCategory }">
      <div id="category_btn" @click="openCategory = !openCategory">
        <p>檔期類別</p>
        <i class="fa fa-arrow-left"></i>
      </div>
      <ul>
        <li :class="{ 'active': cate.category_id === now_category[0], 'category_item': true }" v-for="cate in categorys"
          :key="'category' + cate.category_id" @click="changeCategory(cate.category_id, cate.name)">{{ cate.name }}<i
            class="fa fa-circle"></i></li>
      </ul>
    </div>
    <div id="searchbox">
      <moreButtom class="searchbtn" :class="{ 'searchbox': item.status }"
        @click.native="changeRegion(item.id, item.location_id, item.name)" :button_text="item.name" button_href=""
        v-for="item in regions" :key="item.id"></moreButtom>
    </div>

    <h2>{{ now_category[1] }}</h2>
    <scheduleinshow :for_show="for_show" :dataRegioned="dataRegioned" :schedule_extro="schedule_extro"></scheduleinshow>

    <pagination v-model="for_show.page" :page-range="1" :records="dataRegioned.length" :per-page="for_show.per_page"
      :options="page_options" @paginate="clickScroll"></pagination>
    <moreButtom button_text="返回首頁" button_href="/"></moreButtom>
  </div>
</template>

<script>
import IndexTitle from '@/components/index/IndexTitle'
import Pagination from 'vue-pagination-2'
import MoreButton from '@/components/index/MoreButton'
import Recommend from '@/components/index/Recommend'
import scheduleinshow from '@/components/schedule/ScheduleInShow'

export default {
  name: 'schedule_in',
  props: {},
  metaInfo: {
    title: '全年檔期 │ TopLink 上聯國際展覽有限公司', // set a title
    meta: [{                 // set meta
      name: 'description',
      keywords: '上聯,展覽,近期,展覽分類,活動,場次',
      content: '上聯國際展覽北中南各地年逾50場展覽，累積至今已舉辦逾1000場展覽，深耕各產業每年吸引近千萬人觀展，承辦展覽業別有:旅遊展、車展、寵物展、電腦展、加盟展、婦幼展、食品展、運動展、美容展、酒展、3C展、文具展、建材展、家具展、素食展、茶展、佛展、電器展、珠寶展、健康展…等'
    }]
  },
  data() {
    return {
      now_category: ['0', '近期熱門展覽'],
      now_region: ['0', ['0'], '不分區', true],
      categorys: [
        { category_id: '0', name: '近期熱門展覽' },
        { category_id: '1', name: '３Ｃ家電' },
        { category_id: '2', name: '寵物用品' },
        { category_id: '3', name: '婦幼兒童' },
        { category_id: '4', name: '婚紗精品' },
        { category_id: '5', name: '建材傢俱' },
        { category_id: '6', name: '觀光旅遊' },
        { category_id: '7', name: '佛茶素展' },
        { category_id: '8', name: '專業特展' },
        { category_id: '9', name: '創業加盟' },
        { category_id: '10', name: '精緻酒展' },
        { category_id: '11', name: '休閒健康' },
        { category_id: '12', name: '汽機車展' }
      ],
      // regions: [
      //   {id: '0', location_id: ['0'], name: '不分區',status: true},
      //   {id: '1', location_id: ['1','2','4','10','11','15','16','17','19'], name: '北區',status: false},
      //   {id: '2', location_id: ['5','6','7','9','18'], name: '中區',status: false},
      //   {id: '3', location_id: ['3','8','13','14'], name: '南區',status: false}
      // ],
      regions: [],
      dataAll: [],
      page_options: {
        chunk: 5,
        chunksNavigation: 'scroll',
        texts: {
          count: '{from}-{to}/{count} | {from}-{to}/{count} | '
        }
      },
      index: null,
      openCategory: false,
      allData: [],
      inputs: [], //取得所有展資料 (還沒濾)
      before_id: 0,
      for_show: {
        page: 1,
        per_page: 20,
        no_data: false,
      }
    }
  },
  components: {
    'indexTitle': IndexTitle,
    'pagination': Pagination,
    'recommend': Recommend,
    'moreButtom': MoreButton,
    'scheduleinshow': scheduleinshow
  },
  computed: {
    dataRegioned() {
      var vm = this
      var now_region = vm.now_region[1]
      var targets = vm.dataAll.filter((v) => {
        return now_region.indexOf('0') > -1 ? v : now_region.indexOf(v.location_id) > -1
      })
      return targets
    },
    schedule_extro() {
      var vm = this
      var output = []
      for (let i = 0; i < vm.dataRegioned.length; i++) {
        let hasDomain = vm.dataRegioned[i].exhibit_domain
        let hasOldUrl = vm.dataRegioned[i].exhibit_website.url !== ""
        if (hasDomain && !hasOldUrl) {
          let hasInOutput = output.includes('https://' + vm.dataRegioned[i].exhibit_domain.domain)
          if (hasInOutput) {
            if (hasOldUrl) {
              output.push(vm.dataRegioned[i].exhibit_website.url)
            } else {
              output.push('https://demo.top-link.com.tw/' + vm.dataRegioned[i].id)
            }
          } else {
            output.push('https://' + vm.dataRegioned[i].exhibit_domain.domain)
          }
        } else {
          if (hasOldUrl) {
            output.push(vm.dataRegioned[i].exhibit_website.url)
          } else {
            output.push('https://demo.top-link.com.tw/' + vm.dataRegioned[i].id)
          }
        }
      }
      return output
    },
    params() {
      return this.$route.params
    }
  },
  methods: {
    changeCategory(targetId, targetName) {
      var vm = this
      var target = [targetId, targetName]
      vm.now_category = target
      if (vm.params.category_id && vm.params.category_id < vm.categorys.length) {
        vm.$router.replace({ 'name': 'scheduleIn', 'params': { category_id: targetId.toString() } })
      }
      vm.dataAll = []
      vm.refreshCategory(targetId)
      vm.openCategory = false
      vm.changeRegion('0', ['0'], '不分區')
      vm.sameThing()
    },
    changeRegion(id, locationId, name) {
      var vm = this
      var target = [id, locationId, name]
      vm.now_region = target
      vm.regions[vm.before_id].status = false
      vm.regions[id].status = true
      vm.before_id = id
      vm.sameThing()
    },
    sameThing() {
      var vm = this
      vm.for_show.page = 1
      vm.for_show.no_data = false
      vm.clickScroll()
      vm.checkData(2000);
    },
    refreshCategory(targetId) {
      var vm = this
      if (targetId == 0) {
        vm.dataAll = vm.allData
      } else {
        var response = vm.inputs.filter((v) => {
          return v.exhibit_category_id === vm.now_category[0]
        })
        vm.dataAll = response.filter((v) => {
          var now = new Date()
          return now.getFullYear() - Number(v.start_date.slice(0, 4)) <= 1
        })
      }
    },
    loadAll() {
      var vm = this
      var free_ticket_all = process.env.VUE_APP_API + 'tlweb/new_exhibit?sort=start_date%20asc'
      var date = new Date()
      var params = {/*online: '1', */recent: '1', rows: '30', 'end_date': `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}` }
      vm.axios
        .get(free_ticket_all, { params: params })
        .then((res) => {
          vm.allData = vm.dataAll = res.data.data.data
          // console.log("allData",res.data.data.data);
        })
        .catch((err) => {
          console.log('錯誤:' + err)
        })
    },
    checkData(time) {
      setTimeout(() => {
        var vm = this
        vm.for_show.no_data = vm.dataRegioned.length === 0 ? true : false
      }, time)
    },
    clickScroll() {
      document.documentElement.scrollTop = 145
    },
    get_exhibit_location(params) {
      var app = this
      var exhibit_location_range = process.env.VUE_APP_API + 'tlweb/exhibit_location_distribute'
      var location = []
      app.axios
        .get(exhibit_location_range, { params: params })
        .then((res) => {
          let data = res.data.data

          for (let j = 0; j < data.length; j++) {
            location.push(data[j].id)
          }
        })
        .catch((err) => {
          console.log('錯誤:' + err)
        })
      return location
    }
  },
  created() {
    var vm = this
    if (vm.params.category_id && vm.params.category_id < vm.categorys.length) {
      vm.now_category = Object.values(vm.categorys[vm.params.category_id])
      vm.refreshCategory(vm.params.category_id)
    } else {
      vm.loadAll()
    }
    var free_ticket_type = process.env.VUE_APP_API + 'tlweb/new_exhibit'
    var params = { recent: '1', rows: '100' }
    vm.axios
      .get(free_ticket_type, { params: params })
      .then((res) => {
        vm.inputs = res.data.data.data
        // console.log("inputs", res.data.data.data)
      });
    vm.checkData(2500)
  },
  mounted() {
    var app = this
    var temp_all_regions = []

    for (let i = 0; i <= 5; i++) {
      var temp_location = new Object();
      temp_location.id = i

      switch (i) {
        case 0: {
          temp_location.location_id = ['0']
          temp_location.name = '不分區'
          temp_location.status = true
          break
        }
        case 1: {
          temp_location.name = '北區'
          temp_location.status = false
          let params = { range: i }
          temp_location.location_id = app.get_exhibit_location(params)
          break
        }
        case 2: {
          temp_location.name = '中區'
          temp_location.status = false
          let params = { range: i }
          temp_location.location_id = app.get_exhibit_location(params)
          break
        }
        case 3: {
          temp_location.name = '南區'
          temp_location.status = false
          let params = { range: i }
          temp_location.location_id = app.get_exhibit_location(params)
          break
        }
        case 4: {
          temp_location.name = '東區'
          temp_location.status = false
          let params = { range: i }
          temp_location.location_id = app.get_exhibit_location(params)
          break
        }
        case 5: {
          temp_location.name = '國外'
          temp_location.status = false
          let params = { range: i }
          temp_location.location_id = app.get_exhibit_location(params)
          break
        }
      }
      temp_all_regions.push(temp_location)
    }
    app.regions = temp_all_regions
  }
}
</script>

<style>
/* 區域選單 */
#searchbox {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding: 30px 10px 0;
}

#searchbox .more_button {
  margin: 0 5px 5px;
}

.searchbox div a {
  background: #00a0e9;
  color: white;
}

/* 推薦展覽 */
.schedule_in .chinese_title {
  font-size: 39px;
}

.schedule_in #big_title {
  display: block;
  max-width: 1200px;
  margin: 50px auto;
  padding: 0 15px;
}

.schedule_in>div:nth-child(2) .index_title {
  display: none;
}

/* 檔期類別 */
.schedule_in .open {
  box-shadow: -6px 0px 15px -2px rgba(0, 0, 0, 0.22);
  transform: translateX(0) !important;
}

.schedule_in #category_side_bar {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  padding: 0 20px;
  background: white;
  transform: translateX(100%);
  transition: all 0.5s;
}

.schedule_in .open #category_btn {
  background: white !important;
}

.schedule_in .open #category_btn p {
  color: grey;
}

.schedule_in .open #category_btn i {
  transform: rotate(-180deg);
  color: #00a0e9;
}

.schedule_in #category_side_bar #category_btn {
  position: absolute;
  padding: 20px 15px;
  top: 50%;
  left: 0;
  background: #00a0e9;
  transform: translate(-100%, -50%);
  border-radius: 25px 0 0 25px;
  box-shadow: -7px 0px 30px -5px rgba(142, 142, 142, 0.51);
  cursor: pointer;
  transition: all 0.5s;
}

.schedule_in #category_btn p {
  width: 25px;
  text-align: center;
  margin: 5px 0;
  color: white;
  font-size: 21px;
  transition: all 0.5s;
}

.schedule_in #category_btn i {
  font-size: 30px;
  color: white;
  transition: all 0.5s;
}

.schedule_in #category_side_bar ul {
  list-style-type: none;
  margin: 0;
  padding: 20px;
  height: 100%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
}

.schedule_in #category_side_bar ul li {
  display: flex;
  align-items: center;
  color: grey;
  letter-spacing: 1.2px;
  font-size: 21px;
  margin-top: 20px;
  cursor: pointer;
}

.schedule_in #category_side_bar ul li:hover,
.schedule_in #category_side_bar ul li.active {
  color: #00a0e9;
}

.schedule_in #category_side_bar ul i {
  display: block;
  font-size: 14px;
  color: #00a0e9;
  margin-left: 8px;
}

/* 顯示(改變)區域 */
.schedule_in .region_block {
  display: flex;
  justify-content: center;
  max-width: 100%;
  padding: 30px 10px 0;
}

.schedule_in .region_block .select_button {
  margin: 0 1px;
  color: #00a0e9;
}

.schedule_in .region_block .select_button:hover {
  color: white;
}

.schedule_in h2 {
  font-size: 39px;
  text-align: center;
}

/* 切換頁數 */
.schedule_in .VuePagination ul {
  list-style-type: none;
  display: flex;
  justify-content: center;
  padding: 0;
  margin: 50px 0 20px;
}

.schedule_in .VuePagination ul .page-item {
  width: 50px;
  height: 50px;
  line-height: 44px;
  margin: 0px 3px;
  border: 2px solid #cccccc;
  text-align: center;
}

.schedule_in .VuePagination ul .page-item:hover {
  border: 2px solid #00a0e9;
}

.schedule_in .VuePagination ul .page-item.active {
  background: #00a0e9;
  border: 2px solid #00a0e9;
}

.schedule_in .VuePagination ul .page-item.active a {
  color: white;
}

.schedule_in .VuePagination ul .page-item a {
  display: block;
  width: 100%;
  height: 100%;
  text-decoration: none;
  color: #808080;
  font-size: 17px;
}

.schedule_in .VuePagination__count {
  display: none;
}

/* 1600px */
@media (max-width: 1600px) {
  .schedule_image_box {
    width: 90%;
  }
}

/* 768px */
@media (max-width: 768px) {
  .schedule_in .region_block .select_button {
    width: 80px;
  }

  .schedule_in .region_block .btm_box {
    font-size: 17px;
  }
}

/* 576px */
@media (max-width: 576px) {
  .schedule_in .recommend {
    display: none;
  }

  .schedule_in .open #category_btn i {
    padding-left: 0;
    padding-right: 5px;
  }

  .schedule_in #category_side_bar #category_btn {
    padding: 12px 7px;
  }

  .schedule_in #category_btn p {
    font-size: 17px;
  }

  .schedule_in #category_btn i {
    font-size: 21px;
    padding-left: 5px;
  }

  .schedule_in #category_side_bar ul {
    padding: 10px;
  }

  .schedule_in #category_side_bar ul li {
    font-size: 17px;
    margin-top: 15px;
  }

  .schedule_in #category_side_bar ul i {
    font-size: 12px;
  }

  .schedule_in h2 {
    font-size: 29px;
  }

  .schedule_in #big_title {
    display: none;
  }
}
</style>
